import {Nullable} from "../../models/common/Nullable";
import {APP_CONFIG} from "../../config/GeneralConfig";
import {ErrorAction, ReduxAction} from "../../models/common/ActionTypes";
import {Observable, of} from "rxjs";
import {ofType, StateObservable} from "redux-observable";
import {AppState} from "../../reducers/RootReducer";
import {catchError, map, mergeMap, switchMap} from "rxjs/operators";
import {ajax} from "rxjs/ajax";
import {eventNotificationError} from "../common/EventNotificationActions";
import {OutgoingInvoiceModule} from "../../models/accounting/AccountBook";
import {OutgoingInvoiceProjectTaskTimeItem} from "../../models/accounting/OutgoingInvoiceProjectTaskTimeItem";
import {ProjectId} from "../../models/projects/Project";
import {Identifier} from "../../models/common/Identifier";
import {TimePeriodable} from "../../models/common/TimePeriodable";

/** backend api path */
function apiPath( id: Nullable< number > = null ): string {
    const uri = 'invoices/outgoing/items/time'
    if( id === null ) {
        return APP_CONFIG.baseWeb + uri;
    } else {
        return APP_CONFIG.baseWeb + uri  + id;
    }
}


/** union of all Bill related action types */
export type OutgoingInvoiceProjectTaskTimeItemViewActionTypes = FetchOutInvoiceProjectTaskTimeItemActionTypes



/**
 * fetch list of bills action types
 */
export interface FetchOutInvoiceProjectTaskTimeItemAction extends ProjectId, ReduxAction< typeof FETCH_OUT_INVOICES_PROJECT_TASK_TIME_ITEM > {
    stageIds: Identifier<number>[]
    datePeriod: TimePeriodable
}
export interface FetchOutInvoiceProjectTaskTimeItemSuccessAction extends ReduxAction<typeof FETCH_OUT_INVOICES_PROJECT_TASK_TIME_ITEM_SUCCESS > {
    payload: OutgoingInvoiceProjectTaskTimeItem[]

}
export interface FetchOutInvoiceProjectTaskTimeItemErrorAction extends  ErrorAction< typeof FETCH_OUT_INVOICES_PROJECT_TASK_TIME_ITEM_ERROR >{}

export type FetchOutInvoiceProjectTaskTimeItemActionTypes = FetchOutInvoiceProjectTaskTimeItemAction
    | FetchOutInvoiceProjectTaskTimeItemSuccessAction
    | FetchOutInvoiceProjectTaskTimeItemErrorAction
/**
 * redux action constants
 */
export const FETCH_OUT_INVOICES_PROJECT_TASK_TIME_ITEM = "FETCH_OUT_INVOICES_PROJECT_TASK_TIME_ITEM";
export const FETCH_OUT_INVOICES_PROJECT_TASK_TIME_ITEM_SUCCESS = "FETCH_OUT_INVOICES_PROJECT_TASK_TIME_ITEM_SUCCESS";
export const FETCH_OUT_INVOICES_PROJECT_TASK_TIME_ITEM_ERROR = "FETCH_OUT_INVOICES_PROJECT_TASK_TIME_ITEM_ERROR";

/**
 * redux action functions
 */
export function fetchOutInvoiceProjectTaskTimeItem(
    projectId: Identifier<number>,
    stageIds: Identifier<number>[],
    datePeriod: TimePeriodable
) : FetchOutInvoiceProjectTaskTimeItemAction {
    return { type: FETCH_OUT_INVOICES_PROJECT_TASK_TIME_ITEM, projectId, stageIds, datePeriod };
}
export function fetchOutInvoiceProjectTaskTimeItemSuccess( payload: OutgoingInvoiceProjectTaskTimeItem[] ) : FetchOutInvoiceProjectTaskTimeItemSuccessAction {
    return { type: FETCH_OUT_INVOICES_PROJECT_TASK_TIME_ITEM_SUCCESS, payload };
}
export function fetchOutInvoiceProjectTaskTimeItemError( error: Error ): FetchOutInvoiceProjectTaskTimeItemErrorAction {
    return { type: FETCH_OUT_INVOICES_PROJECT_TASK_TIME_ITEM_ERROR, error };
}

/**
 * redux observable to fetch bills from api
 */
export function fetchOutInvoiceProjectTaskTimeItemEpic(
    action$: Observable< FetchOutInvoiceProjectTaskTimeItemAction >,
    store$: StateObservable< AppState >
) {
    return action$.pipe(
        ofType( FETCH_OUT_INVOICES_PROJECT_TASK_TIME_ITEM ),
        mergeMap(action => {

            const stageIdParam = action.stageIds.map( _stageId => "stageIds="+_stageId.rawValue ).join("&");
            const startAtParam = "startAt="+ (
                typeof action.datePeriod.startAt === "number"
                ? ( new Date( action.datePeriod.startAt ) ).getTime()
                : action.datePeriod.startAt.getTime()
            );
            const finishAtParam = "finishAt="+ (
                typeof action.datePeriod.finishAt === "number"
                ? ( new Date( action.datePeriod.finishAt ) ).getTime()
                : action.datePeriod.finishAt.getTime()
            );
            const path = `${ apiPath() }/projects/${ action.projectId.rawValue }?${ stageIdParam }&${ startAtParam }&${ finishAtParam }`;



            return ajax(
                APP_CONFIG.getRequestObject( path )
            ).pipe(
                map(response => {
                    return fetchOutInvoiceProjectTaskTimeItemSuccess(
                        response.response as OutgoingInvoiceProjectTaskTimeItem[]
                    )
                }),
                catchError(error => of(
                    fetchOutInvoiceProjectTaskTimeItemError( error),
                    eventNotificationError(error, store$, OutgoingInvoiceModule.identifier, "fetchOutInvoiceProjectTaskTimeItem")
                ))
            );

        })
    );
}